import * as React from "react";
import { LoadingButton } from "@mui/lab";
import "./index.scss";

const Button = ({
  onClick,
  label,
  icon,
  className,
  type,
  primary,
  secondary,
  tertiary,
  isLoading,
  isDisabled,
  iconButton = false,
  border = false,
  modalButtons = false,
  link = false,
}) => {
  return (
    <div className="button-container">
    {icon && tertiary && (
        <div
          onClick={isLoading ? ()=>{} : onClick}
          className={`tertiary icon-btn px-3 d-flex align-items-center justify-content-center rounded-pill ${
            isDisabled ? "disabled-btn" : ""
          } ${modalButtons ? "modalButton" : ""} ${className}`}
        >
          {isLoading ? (
            <LoadingButton loading variant="" className="loading py-2" />
          ) : (
            <>
              <span className="icon mr-2">{icon}</span>
              <button type={type} className="fw-bold border-0 bg-transparent" disabled={isDisabled}>
                {label}
              </button>
            </>
          )}
        </div>
      )}
      {icon && secondary && (
        <div
          onClick={isLoading ? ()=>{} : onClick}
          className={`secondary icon-btn px-3 d-flex align-items-center justify-content-center rounded-pill ${
            isDisabled ? "disabled-btn" : ""
          } ${modalButtons ? "modalButton" : ""} ${className}`}
        >
          {isLoading ? (
            <LoadingButton loading variant="" className="loading py-2" />
          ) : (
            <>
              <span className="icon mr-2">{icon}</span>
              <button type={type} className="fw-bold border-0 bg-transparent" disabled={isDisabled}>
                {label}
              </button>
            </>
          )}
        </div>
      )}
      {icon && primary && (
        <div
          onClick={isLoading ? ()=>{} : onClick}
          className={`primary d-flex align-items-center justify-content-center rounded-pill ${
            isDisabled ? "disabled-btn" : ""
          } ${className}`}
        >
          {isLoading ? (
            <LoadingButton loading variant="" className="loading py-2" />
          ) : (
            <>
              <span className="icon mr-2">{icon}</span>
              <button type={type} className="fw-bold border-0 bg-transparent" disabled={isDisabled}>
                {label}
              </button>
            </>
          )}
        </div>
      )}
      {!icon && primary && (
        <div
          onClick={isLoading ? ()=>{} : onClick}
          className={`primary d-flex align-items-center justify-content-center rounded-pill ${className} ${
            isDisabled ? "disabled-btn" : ""}`}
        >
          {isLoading ? (
            <LoadingButton loading variant="" className="loading py-2" />
          ) : (
            <button
              type={type}
              className="fw-bold border-0 bg-transparent"
              disabled={isDisabled}
            >
              {label}
            </button>
          )}
        </div>
      )}
      {secondary && !icon && (
        isLoading ? (
          <div
            className={`secondary rounded-pill bg-white d-flex align-items-center justify-content-center ${className} ${
              isDisabled ? "disabled-btn" : ""
            } ${border ? "border" : ""} ${
              modalButtons ? "modalSecondaryButton" : ""
            } ${className}`}
          >
            <LoadingButton loading variant="" className="secondary loading py-0" />
          </div>
        ) : (
          <button
            className={`secondary rounded-pill bg-white ${className} ${
              isDisabled ? "disabled-btn" : ""
            } ${border ? "border" : ""} ${
              modalButtons ? "modalSecondaryButton" : ""
            } ${className}`}
            onClick={onClick}
            type={type}
            disabled={isDisabled}
          >
            {label}
          </button>
        )
      )}
      {iconButton && (
        <button
          className={`icon-button ${className}`}
          onClick={onClick}
          type={type}
          disabled={isDisabled}
        >
          {icon}
        </button>
      )}
      {link && (
        <div
          onClick={onClick}
          className={`link px-3 d-flex align-items-center justify-content-center rounded-pill ${
            icon ? " icon-btn" : ""
          } ${isDisabled ? "disabled-btn" : ""}  ${className}`}
        >
          {icon && <span className="icon mr-2">{icon}</span>}
          <button type={type} className="fw-bold border-0 bg-transparent">
            {label}
          </button>
        </div>
      )}
    </div>
  );
};

export default Button;
